document
  .querySelector('[data-buy-now-button]')
  .addEventListener('click', async () => {

    const variantId = document.querySelector(
      'input[name="id"]'
    ).value;

    await fetch('/cart/clear.js', {
      method: 'POST'
    });

    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1
          }
        ]
      })
    });

    window.location.href = '/checkout';
  });